import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import PracticeLeftSidebarTwoGridSectionOne from '../../components/practice-components/PracticeLeftSidebarTwoGridSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const PracticeLeftSidebarTwoGridOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Practice Left Sidebar Two Grid 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Practice Left Sidebar Two Grid 1"
        />
        
        <PracticeLeftSidebarTwoGridSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default PracticeLeftSidebarTwoGridOne;